var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48672 0.338867C4.1165 0.338867 2.80241 0.890253 1.83352 1.87173C0.864629 2.8532 0.320313 4.18436 0.320312 5.57237V31.7399C0.320313 33.1279 0.864629 34.4591 1.83352 35.4406C2.80241 36.422 4.1165 36.9734 5.48672 36.9734H36.4852C37.8554 36.9734 39.1695 36.422 40.1384 35.4406C41.1073 34.4591 41.6516 33.1279 41.6516 31.7399V5.57237C41.6516 4.18436 41.1073 2.8532 40.1384 1.87173C39.1695 0.890253 37.8554 0.338867 36.4852 0.338867H5.48672ZM36.4852 2.95562C37.1703 2.95562 37.8273 3.23131 38.3118 3.72205C38.7962 4.21279 39.0684 4.87837 39.0684 5.57237V22.5813L29.3116 17.4865C29.0694 17.3635 28.7951 17.3209 28.5276 17.3646C28.2601 17.4082 28.013 17.536 27.8211 17.7298L18.2374 27.438L11.3661 22.8011C11.118 22.6338 10.8204 22.5585 10.5238 22.5881C10.2272 22.6176 9.94981 22.7502 9.73868 22.9633L2.90352 29.1232V5.57237C2.90352 4.87837 3.17568 4.21279 3.66012 3.72205C4.14457 3.23131 4.80161 2.95562 5.48672 2.95562H36.4852Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndownload);
export default __webpack_public_path__ + "static/media/undownload.38743398.svg";
export { ForwardRef as ReactComponent };